import React, { forwardRef } from 'react';
import { cx } from 'linaria';
import { headerFullScreenClassName, stickyClassName } from './styles';

type StickyContainerProps = React.PropsWithChildren<{
  isBot: boolean;
  disableSticky: boolean;
}>;

export const DATA_QA = 'sticky-header';

export const StickyContainer = forwardRef<HTMLDivElement, StickyContainerProps>((props, ref) => {
  if (props.isBot || props.disableSticky) {
    return null;
  }

  return (
    <div
      data-component-content="sticky-header"
      className={cx(headerFullScreenClassName, stickyClassName)}
      ref={ref}
      data-qa={DATA_QA}
    >
      {props.children}
    </div>
  );
});
